import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import { NotificationProvider } from "./NotificationContext";

/**
 * NotificationProviderWrapper
 *
 * Convenience wrapper for this project that gets session data from AuthContext
 * and passes it as props to NotificationProvider.
 *
 * For other projects, you can use NotificationProvider directly with props:
 * <NotificationProvider orgId="123" userId="user1" collectionName="notifications">
 */
export const NotificationProviderWrapper = ({ children, collectionName = "document_tasks" }) => {
   const authContext = useContext(AuthContext);
   const authReady = authContext?.authReady || false;
   const userClaims = authContext?.userClaims || null;
   const orgInfo = authContext?.orgInfo || null;

   const userId = userClaims?.userId || null;
   const orgBucketId = authReady ? (orgInfo?.orgBucketId || null) : null;

   return (
      <NotificationProvider
         orgId={orgBucketId}
         userId={userId}
         collectionName={collectionName}>
         {children}
      </NotificationProvider>
   );
};

